import React from "react";
import loader from "../../../../images/ajax-loader.gif";

function ScreenOverlayLoader({ isLoading }) {
  return (
    isLoading && (
      <div class="offcanvas-overlay d-flex flex-row justify-content-center align-items-center">
        <img src={loader} height="40px" />
      </div>
    )
  );
}
export default ScreenOverlayLoader;
